import { Input, Directive } from '@angular/core';

import {ControlValueAccessor} from '@angular/forms';

import {BaseControl} from '../controls';

/**
 * Basic control model extended from all shared components,
 * which are created as form controls
 */
@Directive()
export abstract class BaseComponent<ValueType, ChangeValueAttributeType, ControlType> implements ControlValueAccessor {
    protected readonly countryIconClassPrefix: string;

    public value: ValueType;
    public onChange: (value: ValueType) => void;
    public onTouched: () => void;

    @Input() public control: BaseControl<ValueType>;
    @Input() public formControlName: string;

    protected constructor(protected controlContainer) {
        this.countryIconClassPrefix = 'flag flag-';

        if (!this.formControlName) {
            this.formControlName = '';
        }
    }

    protected checkInvalid(): void {
        if (this.controlContainer) {
            const control = this.controlContainer.control.get(this.control.name);

            this.control.invalid = control && control.invalid;
        }
    }

    abstract asFormsControl(): ControlType;

    abstract changeValue(attribute: ChangeValueAttributeType): void;

    /**
     * ControlValueAccessor methods
     */

    /**
     * Write value from model or form control
     * to the DOM element.
     */
    writeValue(value: ValueType, forceControlValueSet = false): void {
        if (typeof value !== 'undefined') {
            this.value = value;

            if ((typeof value === 'string') || (typeof value === 'number') || (typeof value === 'boolean')) {
                this.control.value = value;
            }
        }
    }

    /**
     * @param fn
     *
     * Register custom on change event handler.
     */
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    /**
     * @param fn
     *
     * Register custom on blur(touched) event handler.
     */
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
    }

    /** **************************** */
}
